

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import icon16ChevronPurpleDown from './images/icon-16-chevron-purple-down.svg';


function CallType(props) {


  return (
    <div className='call-type-wrapper'>
      <h2>פירוט שיחות</h2>
      <div className='call-type-list'>
        {props.callsDetails.map((call, index) => {
          return <button key={index} className='call-item'  onClick={() => {props.onClickCallType(call.type)}}>
            <span className='title'>{call.title}</span>
            <div className='arrow-btn' style={{backgroundImage:icon16ChevronPurpleDown.bg()}}/>
          </button>
        })}
      </div>
    </div>

  );
}

const mapStateToProps = (state) => {
  return {

  };
};
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(CallType);
